import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquare, Radio, Phone, Mic } from 'lucide-react';

const QuickActionsWidget = () => {
  const navigate = useNavigate();
  const [glowEffect, setGlowEffect] = useState(false);

  const handleChatClick = () => {
    setGlowEffect(true);
    setTimeout(() => {
      navigate('/chat');
    }, 300);
  };

  return (
    <Card className="bg-gradient-to-br from-zinc-900 to-zinc-800 border-zinc-700 overflow-hidden">
      <CardHeader className="pb-2 sm:pb-3 p-4 sm:p-6">
        <CardTitle className="text-base sm:text-lg font-bold text-white flex items-center gap-2">
          <Radio className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
          Quick Access
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 sm:space-y-3 p-4 sm:p-6 pt-0">
        {/* Chat Access */}
        <Button
          onClick={() => navigate('/chat')}
          className="w-full h-12 sm:h-14 bg-gradient-to-r from-primary to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <MessageSquare className="h-5 w-5 sm:h-6 sm:w-6 mr-2" />
          Team Chat öffnen
        </Button>

        {/* Info Text */}
        <div className="text-xs text-zinc-500 text-center pt-2 border-t border-zinc-700">
          💡 Tipp: Installiere die App auf deinem Homescreen für schnellsten Zugriff
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActionsWidget;
